<template>
  <VerboseLoading :isLoading="isLoading" style="background-color:#e6e6e6;">
    <v-layout justify-start column style="background-color:#e6e6e6;" :class="{ mini: collapseMainMenu }">
      <v-navigation-drawer class="sidebar-menu" :mini-variant="collapseMainMenu" mini-variant-width="55"
        :class="{ 'white-menu-theme': useLightTheme }" v-model="drawer" app :mobile-break-point="960" dark>
        <v-layout fill-height>
          <MainMenu v-if="menuType !== 'case'" :menuType="menuType"></MainMenu>
          <InCaseMenu v-if="menuType === 'case'" :referrer="referrer"></InCaseMenu>
        </v-layout>
      </v-navigation-drawer>
      <v-toolbar class="fixed-toolbar" fixed style="z-index:61" app clipped-left color="primary" height="50px">
        <v-toolbar-side-icon dark @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
        <div class="logo-wrapper" :style="$vuetify.breakpoint.smAndDown && 'width:auto'">
          <Logo></Logo>
        </div>
        <v-layout row fluid>
          <v-flex shrink class="menu-toggle" v-if="isAdminMode">
            <span v-bind:class="{ active: !menuToggle }">Casework</span>
            <v-switch id="menuToggle" v-model="menuToggle" style="display:inline-block"></v-switch>
            <span v-bind:class="{ active: menuToggle }">Config</span>
          </v-flex>
          <v-flex grow class="search">
            <div class="search-wrapper">
              <search-bar></search-bar>
            </div>
          </v-flex>
          <v-flex shrink>
            <v-tooltip color="secondary" bottom>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" dark icon class="ml-3 mt-2" v-on:click.stop="toggleMiniVariant()"><v-icon>{{
                  collapseMainMenu ? 'toggle_off' : 'toggle_on' }}</v-icon></v-btn>
              </template>
              <span>Toggle Mini-menu</span>
            </v-tooltip>
          </v-flex>
          <v-flex shrink class="account">
            <AccountFAB></AccountFAB>
          </v-flex>

        </v-layout>
      </v-toolbar>

      <PopupNotification :message="flashMessageText" :is-error="isFlashMessageError" :timestamp="flashTimestamp"
        :is-warning="isFlashMessageWarning">
      </PopupNotification>
      <v-content class="p-relative pt-0">
        <v-container fluid class="lighten-3 pa-0 offset-top" style=""
          v-bind:class="{ 'with-summary': isSummaryRowActive() }">
          <v-layout v-if="showMessageSidePanel">
            <v-flex lg8>
              <router-view></router-view>
            </v-flex>
            <v-flex lg4>
              <message-side-panel :message=sidePanelContents></message-side-panel>
            </v-flex>
          </v-layout>
          <v-layout v-else-if="showDocumentSidePanel">
            <v-flex lg6>
              <router-view></router-view>
            </v-flex>
            <v-flex lg6>
              <case-document-side-panel :documentFieldName="documentWindow.field.name"
                :fileAttachment="documentWindow.fileAttachment"></case-document-side-panel>
            </v-flex>
          </v-layout>
          <v-layout v-else>
            <v-flex>
              <router-view></router-view>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>


      <clipboard-bar></clipboard-bar>
      <EmailWindow :emailWindowCtx="emailWindow" :emailWindowToggled="emailWindow.emailWindowToggled"
        :user="currentUser">
      </EmailWindow>
    </v-layout>
  </VerboseLoading>

</template>

<script>
import EmailWindow from "@/components/comms/EmailWindow.vue"
import MainMenu from "@/components/navigation/MainMenu.vue"
import InCaseMenu from "@/components/navigation/InCaseMenu.vue"
import SearchBar from "@/components/search/SearchBar.vue"
import AccountFAB from "@/components/AccountFAB.vue"
import PopupNotification from "@/components/notifications/PopupNotification"
import ClipboardBar from '@/components/shared/clipboardBar.vue'
import MessageSidePanel from '@/components/comms/MessageSidePanel.vue'
import CaseDocumentSidePanel from '@/components/cases/case-edit/CaseDocumentSidePanel.vue'
import Logo from "@/components/Logo.vue"
import { mapState } from "vuex"
import VerboseLoading from '../shared/VerboseLoading.vue'

export default {
  name: "app2",
  data: () => ({
    pageTitle: "Overview",
    searchTerm: "",
    drawer: true,
    mini: true,
    right: null,
    allNavItems: []
  }),
  props: { source: String },
  components: { EmailWindow, VerboseLoading, MainMenu, InCaseMenu, SearchBar, AccountFAB, PopupNotification, ClipboardBar, MessageSidePanel, Logo, CaseDocumentSidePanel },
  computed: {
    ...mapState({
      isLoading: state => state.ui.loading,
      flashMessageText: state =>
        state.ui.flashMessage ? state.ui.flashMessage.message : undefined,
      isFlashMessageError: state =>
        state.ui.flashMessage
          ? state.ui.flashMessage.severity === "error"
          : false,
      isFlashMessageWarning: state =>
        state.ui.flashMessage
          ? state.ui.flashMessage.severity === "warning"
          : false,
      flashTimestamp: state =>
        state.ui.flashMessage ? state.ui.flashMessage.timestamp : undefined,
      menuType: state => state.ui.menu,
      referrer: state => state.ui.referrer,
      useLightTheme: state => state.currentUser && state.currentUser.me && state.currentUser.me.theme === "light",
      showMessageSidePanel: state => state.ui.showMessageSidePanel,
      showDocumentSidePanel: state => state.ui.showDocumentSidePanel,
      collapseMainMenu: state => !state.ui.keepMainMenuExpanded,
      sidePanelContents: state => state.ui.sidePanelContents,
      emailWindow: state => state.ui.emailWindow,
      documentWindow: state => state.ui.documentWindow,
      currentUser: state => state.currentUser,
      currentRouteName: state => state.cbroute.name
    }),
    isAdminMode() {
      return this.currentUser && !!this.currentUser.isAccountAdmin
    },
    currentRoute() { return this.$route },
    menuToggle: {
      get() {
        return (!(this.menuType === "main" || this.menuType === "case"))
      },
      set() {
        this.toggleMenu()
      }
    }
  },
  methods: {
    updateSecondaryNavItems() { },
    updateSecondaryNavDrawer() { },
    logout() {
      this.$store.dispatch("logout")
      this.$router.push("/")
    },
    toggleMenu() {
      this.$store.dispatch("switchMenu", { opposite: true })
    },
    toggleMiniVariant() {
      this.$store.dispatch("toggleMainMenuExpansion")
    },
    isSummaryRowActive() {
      const activeRoutes = [
        'Case',
        'CaseTimeline',
        'CaseNotes',
        'CaseConversations',
        'CaseDocuments',
        'CaseTasks',
        'CaseRelations'
      ]
      return activeRoutes.includes(this.currentRouteName)
    }
  }
}
</script>

<style lang="stylus">
@import '../../stylus/main';

.v-card .container {
  overflow: scroll;
  height: calc(100% - 48px);
  max-height: calc(100% - 48px);
}
</style>
